module.exports = __webpack_public_path__ + "img/imag2.f4a93537.png";